'use client';
class HTTPError extends Error {
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `со статус-кодом ${status}` : 'неизвестной ошибкой';
        super(`Запрос завершился ${reason}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
        Object.setPrototypeOf(this, HTTPError.prototype);
    }
}

export { HTTPError };
//# sourceMappingURL=HTTPError.js.map
